import React, {useState, useEffect, useRef} from 'react';
import {findPdvSalesPrinted, forcePdvSalePrinting} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import {formatDateTimeString} from "../../utils/utils";

const PdvSalesPrintedToPrintAgain = () => {
    const [sales, setSales] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);

    async function makeQuery(query) {
        try {
            setLoading(true);
            let data = await findPdvSalesPrinted() || [];
            if (query.length > 0) {
                data = data.filter(f => f.id === Number(query));
            }
            data.sort((a, b) => new Date(a.saleDate) - new Date(b.saleDate));
            data.forEach(c => c.checked = false);
            setSales(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { makeQuery(queryString); }, [queryString]);

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    }

    const handleInputChange = (e) => {
        setQueryString(removeSpecialChars(e.target.value).toUpperCase());
    };

    const onCheckBoxChange = (index) => {
        const updated = [...sales];
        updated[index].checked = !updated[index].checked;
        setSales(updated);
        setQueryString('');
    };

    return (
        <>
            <div className="header-label">Reimprimir Pedido</div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                 className="input-container">
                <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                       onChange={handleInputChange} onFocus={(e) => e.target.select()}/>
                <button id="clearButton" onClick={() => { setQueryString(''); inputQueryString.current.focus(); }}>X</button>
            </div>
            <div style={{flexGrow: 1, overflowY: 'auto'}}>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '10px'}}/>
                        <col style={{width: '150px'}}/>
                        <col style={{width: '150px'}}/>
                        <col style={{width: '120px'}}/>
                        <col style={{width: '150px'}}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th/>
                        <th>Comanda</th>
                        <th>Mesa</th>
                        <th>Garçom</th>
                        <th>Data</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {sales.map((sale, index) => (
                        <tr key={index} style={{backgroundColor: sale.checked ? 'var(--warning-color)' : 'white'}}>
                            <td>
                                <input type="checkbox" checked={sale.checked} onChange={() => onCheckBoxChange(index)}/>
                            </td>
                            <td><div>{sale.customer ? sale.customer.name : sale.customerName}</div></td>
                            <td><div>{sale.table ? sale.table.name : ''}</div></td>
                            <td><div>{sale.user?.name || sale.userName || 'Não informado'}</div></td>
                            <td><div>{formatDateTimeString(sale.saleDate)}</div></td>
                            <td>
                                {sales.filter(c => c.checked).length === 0 && (
                                    <button onClick={async () => {
                                        await forcePdvSalePrinting([sale.id]);
                                        setSales(sales.filter(s => s.id !== sale.id));
                                    }}>Reimprimir</button>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    {sales.length === 0 && <tfoot><tr><td colSpan={6}>Nenhum item encontrado</td></tr></tfoot>}
                </table>
            </div>
            {sales.filter(c => c.checked).length > 0 && (
                <ActionButtonsManagerView>
                    <button onClick={async () => {
                        const ids = sales.filter(c => c.checked).map(c => c.id);
                        await forcePdvSalePrinting(ids);
                        setSales(sales.filter(c => !c.checked));
                    }}>Reimprimir</button>
                </ActionButtonsManagerView>
            )}
        </>
    );
};

export default PdvSalesPrintedToPrintAgain;
